import React from 'react';

export type MainData = {
  isInitialized: boolean;
  isValidatingToken: boolean;
};

export const DEFAULT_MAIN_DATA: MainData = {
  isInitialized: false,
  isValidatingToken: false,
};

export const MainDataContext = React.createContext<MainData>(DEFAULT_MAIN_DATA);

export const useMainData = () => React.useContext(MainDataContext);
